import React from "react";

import { ReactComponent as IconSurvey } from "../../assets/svg/pico_icon_survey_screen.svg";
import { ReactComponent as IconHint } from "../../assets/svg/pico_icon_hint_screen.svg";
import {
  CHAT_BUBBLE_MODAL_PAGES,
  ChatBubbleModalPage,
} from "../../constants/teaching_hint";

import styles from "./ChatBubbleIcon.module.scss";
type ChatBubbleIconProps = {
  onClose: () => void;
  modalPage: ChatBubbleModalPage;
};
const ChatBubbleIcon: React.FC<ChatBubbleIconProps> = ({
  onClose,
  modalPage,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon} onClick={onClose}>
        {modalPage === CHAT_BUBBLE_MODAL_PAGES.HINTS ? (
          <IconHint />
        ) : (
          <IconSurvey />
        )}
      </div>
    </div>
  );
};

export default ChatBubbleIcon;
